import React from 'react';
import HeroFatigueManagementPolicy from './hero-fatigue-management-policy';
import Menu from '../../common/menu';
import Footer from '../../common/footer';
import FatigueManagementPolicy from './fatigue-management-policy';


function MainFatigueManagementPolicy() { 
    return (
        <div className="content-wrapper">
            <Menu />
            <HeroFatigueManagementPolicy />
            <FatigueManagementPolicy />
            <Footer />
        </div>
    );
}

export default MainFatigueManagementPolicy;